import React, {Fragment} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Alert, Button, Col, Collapse, Row, Tooltip} from "antd";
import {MARGIN_MD, PADDING_SM} from "../../../../../../styles/constants";
import {BatchedArrayData, onDownloadErrors} from "./utils";

const mapStateToProps = ({
                             config, scenes: {mappingHandler: {mappingSet: {wizard, index}}}
                         }) => ({
    validateStatus: wizard.validateDataStatus,
    selectedMappingSet: index.selectedMappingSet,
    maxRowsErrorMappingValidation: config.dataManagement.maxRowsErrorMappingValidation,
});

const ValidationErrorItem = ({errorType, data, t, maxRowsErrorMappingValidation}) => {
    if (!data) {
        return null;
    }
    if (errorType === "TextFormatErrors") {
        return <BatchedArrayData maxRowsErrorMappingValidation={maxRowsErrorMappingValidation} t={t} data={data} renderData={(item) => (
            <Fragment>
                <span>{item.componentId}</span>
                <ul>
                    {item.valuesErrors.map(err => <li>{err.value}: {err.errors.join(",")}</li>)}
                </ul>
            </Fragment>
        )}/>;
    }
    if (!Array.isArray(data)) {
        return (
            <BatchedArrayData maxRowsErrorMappingValidation={maxRowsErrorMappingValidation} t={t} data={Object.keys(data)} renderData={(field, idx) => (
                <Row key={idx} type="flex"
                     style={{flexDirection: "column", paddingBottom: PADDING_SM, width: "100%"}}
                     gutter={PADDING_SM}>
                    <Col>
                                    <span style={{fontWeight: "bold"}}>
                                        {field}
                                    </span>
                    </Col>
                    <Col>
                        <span>{data[field].join(", ")}</span>
                    </Col>
                </Row>
            )}/>
        )
    }
    return <BatchedArrayData maxRowsErrorMappingValidation={maxRowsErrorMappingValidation} t={t} data={data} renderData={(item, idx) => (
        <p key={idx}>
            <span style={{fontWeight: "bold"}}>{idx + 1}&nbsp;&nbsp;</span> {item}
        </p>
    )}/>;
}

const MappingSetValidateData = ({t, validateStatus, selectedMappingSet, maxRowsErrorMappingValidation}) => {
    if (!validateStatus) return null
    if (validateStatus.status === "Error") {
        return <Alert type="warning"
                      message={validateStatus.errorMessage.replace("MA API: InternalServerError -", "").trim()}
                      showIcon/>
    }


    return (
        <Fragment>
            {!!validateStatus && (!validateStatus.status || !validateStatus.errorMessage) && (
                <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: MARGIN_MD}}>
                    <Tooltip title={t("scenes.mappingHandler.MappingSet.tooltip.dataValidationDownloadButton")}>
                        <Button
                            icon="download"
                            onClick={() => onDownloadErrors(validateStatus, selectedMappingSet)}
                            type="primary"
                            disabled={!validateStatus || !Object.keys(validateStatus).length || (!!validateStatus.status && validateStatus.status.trim().toLowerCase() === 'error')}
                        >
                            {t('commons.buttons.download.title')}
                        </Button>
                    </Tooltip>
                </div>
            )}
            <Collapse
                className="nodes-config__node"
            >
                {["CodelistErrors", "DuplicateObservations", "TimePeriodErrors", "TextFormatErrors"].map(errorType =>
                    <Collapse.Panel
                        header={`${t(`scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.${errorType}`)} - ${Array.isArray(validateStatus[errorType]) ? validateStatus[errorType].length : Object.keys(validateStatus[errorType]).length}`}
                        key={errorType}
                        disabled={Array.isArray(validateStatus[errorType]) ? validateStatus[errorType].length === 0 : Object.keys(validateStatus[errorType]).length === 0}
                    >
                        <ValidationErrorItem errorType={errorType} data={validateStatus[errorType]} t={t} maxRowsErrorMappingValidation={maxRowsErrorMappingValidation}/>
                    </Collapse.Panel>)}
            </Collapse>
        </Fragment>

    )
}

export default compose(
    translate(),
    connect(mapStateToProps),
)(MappingSetValidateData);
